<div class="flex flex-col gap-y-6">
  <div class="flex items-start justify-between gap-6">
    <app-page-headline
      class="shrink grow basis-[min-content]"
      [headline]="'pages.clearingDetail.headline' | translate"
      [isLoading]="isLoading"
      [count]="total"
    />

    <div class="flex gap-2">
      <app-back-button />
      <app-button
        data-test-id="mergeButton"
        type="primary"
        [disabled]="
          openConflicts !== 0 ||
          branch?.state !== 'WORKFLOW_EDITING_CONFLICTS' ||
          branch?.processState !== 'ADDRESS_VALIDATION_COMPLETED'
        "
        (trigger)="onMerge()"
      >
        @if (branch?.state === 'WORKFLOW_MERGING') {
          <svg-icon
            data-test-id="mergingIndicator"
            class="size-5 animate-spin"
            src="assets/icons/General/loading-01.svg"
          />
          {{ 'pages.clearingDetail.apply.loadLabel' | translate }}
        } @else {
          <svg-icon class="size-5" src="assets/icons/General/upload-01.svg" />
          {{ 'pages.clearingDetail.apply.label' | translate }}
        }
      </app-button>
    </div>
  </div>

  @if (
    branch &&
    branch.processState !== 'ADDRESS_VALIDATION_COMPLETED' &&
    branch.state !== 'WORKFLOW_FINISHED'
  ) {
    <div
      data-test-id="syncStatus"
      class="flex items-center gap-4 space-y-1 rounded-xl bg-red-75 px-4 py-3"
    >
      <svg-icon class="size-5" src="assets/icons/Arrows/refresh-ccw-03.svg" />
      <div>{{ 'pages.clearingDetail.outOfSync.info' | translate }}</div>
      @if (isValidating) {
        <div data-test-id="validationInProgress">
          {{ 'pages.clearingDetail.outOfSync.syncing' | translate }}
        </div>
        <svg-icon
          class="animate-spin"
          src="assets/icons/General/loading-01.svg"
        />
      }
      <app-button
        data-test-id="reValidationButton"
        type="primary"
        [disabled]="isValidating"
        (trigger)="startReValidation()"
      >
        <svg-icon
          class="size-5"
          src="assets/icons/General/link-broken-01.svg"
        />
        {{ 'pages.clearingDetail.outOfSync.sync' | translate }}
      </app-button>
    </div>
  }

  <app-branch-detail-base
    [filterAllLabel]="'pages.clearingDetail.filter.all' | translate"
    [id]="id"
    [offset]="offset"
    [branch]="branch"
    [showResolvedSwitch]="true"
    [tableColumns]="[
      {
        key: 'isResoluted',
        label: 'models.address.isResoluted.label' | translate,
        width: '50px',
        fixRight: true,
        cellTemplate: booleanCellTemplate,
        sort: false,
        align: 'center',
      },
      {
        key: 'actions',
        label: 'pages.clearingDetail.table.actions.label' | translate,
        width: '56px',
        align: 'right',
        fixRight: true,
        cellTemplate: actionCellTemplate,
        sort: false,
      },
    ]"
    (changeHandler)="onBaseUpdate($event)"
  />
</div>

<ng-template #booleanCellTemplate let-item="item">
  <app-boolean [value]="item" />
</ng-template>

<ng-template
  #actionCellTemplate
  let-currentRow="currentRow"
  let-index="index"
  [typedTemplate]="typeToken"
>
  <app-button
    class="inline-block"
    data-test-id="testButton"
    type="primary"
    shape="circle"
    [title]="'pages.clearingDetail.table.actions.edit.title' | translate"
    [disabled]="branch?.processState !== 'ADDRESS_VALIDATION_COMPLETED'"
    [routerLink]="['./conflict-detail', currentRow.referenceId]"
    [queryParams]="{
      offset: offset + index + 1,
    }"
  >
    <svg-icon src="assets/icons/General/edit-05.svg" />
  </app-button>
</ng-template>
